import injector from './injector';

export default injector;



// WEBPACK FOOTER //
// ./src/components/injector/index.jsx